import { tv } from 'tailwind-variants';

// ─── SearchBar (header dropdown) ─────────────────────────────────────────────

export const resultItemVariants = tv({
  slots: {
    resultItem: [
      'group',
      'flex items-start flex-col',
      'px-3.5 py-2.5',
      'border-b border-gray-100 last:border-b-0',
      'hover:bg-light-gray transition-colors',
    ],
    itemWrapper: ['flex gap-5'],
    imageWrapper: [
      'min-w-[98px] h-[98px]',
      'flex items-center justify-center',
      'border border-light-gray',
    ],
    resultImage: ['w-full h-full', 'grow', 'object-cover'],
    pdfIcon: ['fa-sharp fa-light fa-file-pdf', 'text-5xl text-black'],
    resultContent: ['flex flex-col gap-1 min-w-0'],
    resultTitle: [
      'group-hover:underline',
      'text-[17px] font-bold text-textPrimary leading-[25.5px]',
    ],
    resultSnippet: [
      'font-medium text-[15px] leading-[22px]',
      'text-textPrimary md:line-clamp-6 lg:line-clamp-2',
      '[&>em]:font-black [&>em]:not-italic',
    ],
    resultBadge: [
      'max-w-fit',
      'inline-block px-1.5 py-0.75',
      'text-white text-xs leading-4.5 font-medium uppercase tracking-wide',
      'rounded-[5px]',
    ],
  },
  variants: {
    resultType: {
      srpnet: {
        resultBadge: ['bg-nav-primary'],
      },
      media: {
        resultBadge: ['bg-dark-green'],
      },
      blog: {
        resultBadge: ['bg-orange'],
      },
    },
    isResultPageItem: {
      true: {
        resultTitle: ['mb-4.5'],
        resultBadge: ['mt-5'],
        resultSnippet: ['text-base font-medium leading-6'],
      },
    },
  },
  defaultVariants: {
    resultType: 'srpnet',
  },
});
